"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var Portal_1 = require("./Portal");
exports.Portal = Portal_1.default;
__export(require("./Portal"));
//# sourceMappingURL=index.js.map